import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LangSwitcherDashboardComponent } from './lang-switcher-dashboard.component';
import { TranslationModule } from 'src/app/i18n/translation.module';



@NgModule({
  declarations: [
    LangSwitcherDashboardComponent
  ],
  imports: [
    CommonModule,
    TranslationModule
  ],
  exports: [LangSwitcherDashboardComponent]
})
export class LangSwitcherDashboardModule { }
